<template>
  <div>
    <div class="page-title-box">
      <div class="page-title-right">
      </div>
      <h4 class="page-title">Üldise hinnakirja muutmine</h4>
    </div>

    <div class="card">
      <div class="card-body bg-light py-2">
        <b-form-checkbox v-model="showServicesWithoutPrice" :value="true" :unchecked-value="false">
          Näita hinnastamata teenuseid
        </b-form-checkbox>
      </div>
      <div class="card-body">

        <div class="alert alert-light alert-card-attached">Täida ainult need käibemaksumäärad, mis erinevad vaikimisi väärtusest 20%</div>

        <b-form @reset.prevent="resetValues">

          <table class="table table-sm table-sticky table-vertical-centered table-hover mt-4">
            <thead class="thead">
            <th>Teenus</th>
            <th class="text-right">KM %</th>
            <th class="text-right">Üldhind &euro;</th>
            </thead>
            <tbody>

            <template v-for="item in data">
              <tr v-show="showServicesWithoutPrice || item.price || item.vat || item.originalPrice || item.originalVat">
                <td>{{item.serviceName}}</td>
                <td width="20%" class="text-right p-0 px-1">
                  <validated-form-input :name="'service_vat_' + item.serviceId"
                                        v-model="item.vat"
                                        size="sm"
                                        class="mb-0"
                                        :alignRight="true"
                                        validate="decimal|max_value:99" :validator="$validator"
                                        :decimal="true"/>
                </td>
                <td width="20%" class="text-right p-0 px-1">
                  <validated-form-input :name="'service_price_' + item.serviceId"
                                        v-model="item.price"
                                        size="sm"
                                        class="mb-0"
                                        :alignRight="true"
                                        :validate="(!!item.vat ? 'required|' : '') + 'decimal|max_value:99999'" :validator="$validator"
                                        :decimal="true"/>
                </td>
              </tr>
            </template>
            </tbody>
          </table>

          <div class="d-flex justify-content-between">
            <div class="mr-auto">
              <button type="reset" class="btn btn-danger"><i class="mdi mdi-undo-variant mr-1"></i>Taasta</button>
            </div>
            <button type="button" class="btn btn-link mr-2" @click="goBack"><i class="mdi mdi-arrow-left mr-1"></i>Tagasi</button>
            <button type="button" class="btn btn-success" @click="save"><i class="mdi mdi-check mr-1"></i>Salvesta</button>
          </div>

        </b-form>

      </div>
    </div>
  </div>
</template>

<script>
  import ValidatedFormInput from '@/components/ValidatedFormInput'
  import gateway from '@/services/gateway'

  export default {
    components: {ValidatedFormInput},
    data() {
      return {
        showServicesWithoutPrice: false,
        data: []
      }
    },
    methods: {
      resetValues() {
        this.data.forEach(item => {
          item.price = item.originalPrice
          item.vat = item.originalVat
        })
      },
      goBack() {
        this.$router.push('/pricelist')
      },
      save() {
        this.$validator.validateAll().then(valid => {
          if (!valid) return;
          const prices = this.data
            .filter(p => !!p.price || p.price === 0 || p.vat)
            .map(p => ({serviceId: p.serviceId, price: p.price, vat: p.vat}))
          gateway.post(`/pricelist`, {prices: prices}).then(() => {
            this.$notifications.info('Hinnakiri on salvestatud')
            this.goBack()
          })
        })
      },
      sortByServiceNameAsc(data) {
        data.sort((a, b) => {
          if (a.serviceName < b.serviceName) return -1;
          if (a.serviceName === b.serviceName) return 0;
          return 1;
        })
      },
      loadData() {
        gateway.get(`/pricelist`).then(r => {
          this.data = r.data.map(item => Object.assign({
            originalPrice: item.price,
            originalVat: item.vat
          }, item))
          this.sortByServiceNameAsc(this.data)
        })
      }
    },
    created() {
      this.loadData()
    }
  }
</script>
